import { Bell } from 'lucide-react'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { Badge } from '@/components/ui/badge'
import { useUnreadNotificationCount } from '@/hooks/use-notifications'

export function NotificationMenuItem({ onSelect }: { onSelect: () => void }) {
  const { data: unread = 0 } = useUnreadNotificationCount()
  return (
    <DropdownMenuItem onSelect={onSelect}
      aria-label={unread > 0 ? `Notifications (${unread} unread)` : 'Notifications'}>
      <Bell aria-hidden />
      <span className="flex-1">Notifications</span>
      {unread > 0 && <Badge variant="destructive" aria-hidden>{unread > 9 ? '9+' : unread}</Badge>}
    </DropdownMenuItem>
  )
}
